import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'

// Ant Design
import { Avatar, Empty, Spin, Timeline, Typography, Space } from 'antd'

// slices
import {
    changeHistoryPage,
    clearHistoryTask,
    historyTaskGet,
    tasksState,
} from './tasks.slice'

// helpers
import { unique } from '../../helpers/uniqueArray'
import dayjs from 'dayjs'

function ActivitySectionTimeline() {
    const dispatch = useDispatch()
    const { Text } = Typography

    const {
        pageLimitHistory,
        skipPageHistory,
        currentPageHistory,
        historyTask,
        isNextHistory,
        selectedTask,
        historyStatus,
        selectedSubTask,
        formSubTask,
    } = useSelector(tasksState)

    const [filteredHistoryTask, setFilteredHistoryTask] = useState([])

    useEffect(() => {
        dispatch(
            historyTaskGet({
                skip: skipPageHistory,
                limit: pageLimitHistory,
                taskId:
                    selectedSubTask && formSubTask
                        ? selectedSubTask
                        : selectedTask?._id,
            })
        )
        return () => {
            dispatch(clearHistoryTask())
            setFilteredHistoryTask([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (historyTask?.length > 0) {
            const newArray = unique([...filteredHistoryTask, ...historyTask], '_id')
            setFilteredHistoryTask(newArray)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyTask])

    async function fetchMoreHistory() {
        if (isNextHistory) {
            await dispatch(
                historyTaskGet({
                    skip: skipPageHistory + pageLimitHistory,
                    limit: pageLimitHistory,
                    taskId: selectedTask?._id,
                })
            )
            dispatch(
                changeHistoryPage({
                    currentPage: currentPageHistory + 1,
                    skip: skipPageHistory + pageLimitHistory,
                    pageLimit: pageLimitHistory,
                })
            )
        }
    }

    const getInitials = (name) => {
        if (!name) return ''
        const splitName = name.split(' ')
        return splitName.length > 1
            ? (splitName[0][0] + splitName[1][0]).toUpperCase()
            : splitName[0][0].toUpperCase()
    }

    return (
        <Spin spinning={historyStatus === 'loading'}>
            {filteredHistoryTask?.length === 0 && historyStatus !== 'loading' ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '25vh',
                    }}
                >
                    <Empty description="No Activity Found" />
                </div>
            ) : (
                <div
                    style={{
                        width: '100%',
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        padding: '15px',
                        // border: '1px solid #f0f0f0',
                        borderRadius: 6,
                        // backgroundColor: '#fafafa',
                    }}
                >
                    <InfiniteScroll
                        dataLength={filteredHistoryTask.length}
                        next={fetchMoreHistory}
                        hasMore={isNextHistory}
                        style={{ overflow: 'inherit' }}
                    >
                        <Timeline mode="left">
                            {filteredHistoryTask
                                .sort((a, b) => new Date(b.time) - new Date(a.time)) // newest first
                                .map((task) => (
                                    <Timeline.Item
                                        key={task._id}
                                        dot={
                                            <Avatar
                                                size={32}
                                                style={{ backgroundColor: '#4f46e5', fontSize: 14 }}
                                            >
                                                {getInitials(task?.createdBy[0]?.name)}
                                            </Avatar>
                                        }
                                    >
                                        <Space direction="vertical" size={2}>
                                            <Text strong>{task?.createdBy[0]?.name}</Text>
                                            <div
                                                dangerouslySetInnerHTML={{ __html: task?.description }}
                                                style={{ color: '#595959', fontSize: 13 }}
                                            />
                                            <Text type="secondary" style={{ fontSize: 12 }}>
                                                {dayjs(task?.time).format('DD MMM YYYY, hh:mm A')}
                                            </Text>
                                        </Space>
                                    </Timeline.Item>
                                ))}
                        </Timeline>
                    </InfiniteScroll>
                </div>
            )}
        </Spin>
    )
}

export default ActivitySectionTimeline
